<template>
	<div>
		<div class="bg-container">
			<div class="box" v-for="(item, index) in stepList" :key="index">
				<div v-if="finishValue >= item.number" class="finish" @click="toskip(item.number)">
					<i :class="[activeValue == item.number ? 'el-icon-success' : 'el-icon-circle-check']"></i>
				</div>
				<div
					v-else
					:class="['circular', activeValue == item.number ? 'activeCirular' : 'greyCircular']"
				>
					{{ item.number }}
				</div>
				<span
					:class="[
						activeValue == item.number ? 'activeText' : 'greyText',
						finishValue >= item.number ? 'hovertext' : '',
					]"
					@click="toskip(item.number)"
					>{{ item.text }}</span
				>
				<span class="greyText line" v-if="index != stepList.length - 1">——</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: {
		activeValue: {
			default: 1,
		},
		stepList: {
			type: Array,
		},
	},
	data() {
		return {};
	},

	components: {},

	computed: {
		...mapGetters(['finishValue']),
		queryParam() {
			return this.$route.query;
		},
	},
	methods: {
		toskip(number) {
			if (this.finishValue >= number) {
				this.$store.dispatch('getstepstatus', this.queryParam.id);

				if (this.activeValue == 2 && this.$parent.$refs.component.getselectedItem()) {
					this.$emit('toSkip', number);
				}
				if (this.activeValue != 2) {
					this.$emit('toSkip', number);
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.bg-container {
	display: flex;
	height: 112px;
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	justify-content: center;
	margin-bottom: 10px;
}

.box {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: 400;
	.finish {
		color: #3da1ff;
		// width: 32px;
		// height: 32px;
		font-size: 32px;
		text-align: center;
		margin-right: 10px;
		padding-bottom: 5px;
		cursor: pointer;
	}
	.circular {
		width: 32px;
		height: 32px;
		text-align: center;
		line-height: 28px;
		border-radius: 16px;
		margin-right: 10px;
		color: #333333;
	}
	.line {
		padding: 0px 10px;
	}
	.greyText {
		color: #999999;
	}
	.hovertext:hover {
		color: #3da1ff;
		cursor: pointer;
	}
	.activeText {
		color: #333333;
		font-weight: 600;
	}
	.greyCircular {
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: rgba(0, 0, 0, 0.25);
	}
	.activeCirular {
		background: #3da1ff;
		color: #ffffff;
	}
}
</style>
